<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          Pályázatra jelentkezés
          <span>Jelentkezés pályázatra</span>
        </h1>
      </div>
    </div>

    <section>
    	<div class="container">
    		<router-link style="margin-bottom: 25px;" class="back-button" :to="{ path: '/palyazatok' }"><img src="assets/img/grey-arrow.png" alt=""/>Vissza</router-link>
        <Form v-if="form.fields != undefined && form.fields.length > 0 && form.fields[0].childs.length > 0 && (form.vue_component == null || form.vue_component == '')" :field="form.fields[0]" :childs="form.fields[0].childs" :form="form"></Form>
        <NemzetiFelsooktatasiOsztondij v-if="form.vue_component == 'NemzetiFelsooktatasiOsztondij'"/>
        <UtanpotlasHallgatoiOsztondij v-if="form.vue_component == 'UtanpotlasHallgatoiOsztondij'"/>
        <Unkp v-if="form.vue_component == 'Unkp'"/>
        <Unkp2021 v-if="form.vue_component == 'Unkp2021'"/>
        <Unkp2022 v-if="form.vue_component == 'Unkp2022'"/>
        <Unkp2023 v-if="form.vue_component == 'Unkp2023'"/>
        <EKOP2024 v-if="form.vue_component == 'EKOP2024'"/>
        <EKOP2025 v-if="form.vue_component == 'EKOP2025'"/>
        <DoktoriProgram v-if="form.vue_component == 'DoktoriProgram'"/>
        <RendkivuliSzocialisOsztondij v-if="form.vue_component == 'RendkivuliSzocialisOsztondij'"/>
        <KiemelkedoTudomanyosSportKulturalisOsztondij v-if="form.vue_component == 'KiemelkedoTudomanyosSportKulturalisOsztondij'"/>
    	</div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>

<script>
import Vue from 'vue';
import HTMLHeader from '../tpl_header.vue';
import HTMLFooter from '../tpl_footer.vue';
import ProfileMenu from '../tpl_profile_menu.vue';
import NemzetiFelsooktatasiOsztondij from './nemzeti_felsooktatasi_osztondij.vue';
import UtanpotlasHallgatoiOsztondij from './utanpotlas_hallgatoi_osztondij.vue';
import Unkp from './unkp.vue';
import Unkp2021 from './unkp2021.vue';
import Unkp2022 from './unkp2022.vue';
import Unkp2023 from './unkp2023.vue';
import EKOP2024 from './ekop2024.vue';
import EKOP2025 from './ekop2025.vue';
import DoktoriProgram from './doktori_program.vue';
import RendkivuliSzocialisOsztondij from './rendkivuli_szocialis_osztondij.vue';
import KiemelkedoTudomanyosSportKulturalisOsztondij from './kiemelkedo_tudomanyos_sport_kulturalis_osztondij.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu,
    NemzetiFelsooktatasiOsztondij,
    UtanpotlasHallgatoiOsztondij,
    Unkp,
    Unkp2021,
    Unkp2022,
    Unkp2023,
    EKOP2024,
    EKOP2025,
    DoktoriProgram,
    RendkivuliSzocialisOsztondij,
    KiemelkedoTudomanyosSportKulturalisOsztondij
  },
  data: function() {
    return {
      form: {}
    }
  },
  mounted: function() {
  	var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/get/' + this.$route.query.id, {
	    method: 'GET',
	    data: _this.query,
	    success: function(response) {
	      if (response.error == false) {
          _this.form = response.form;
	      } else
	        swal("Hiba!",response.error,"error");
	    }
	});
  }
}

</script>


// WEBPACK FOOTER //
// form.vue?54df78be